<script>
export default {


    props: {
        user: {
            required: true,
            type: Object
        }
    }
}
</script>
<template>

    <div class="text-left flex justify-center">
        <div class="w-half mb-4 p-2 card-1">
            <div class="mb-4 text-gray-600">
                Thank you for accepting your invitation to {{user.company.name}}!  Your link to your password is below, and you can go directly home as well.
            </div>

            <div class="flex justify-around">
                <a class="inputbutton1 rounded" :href="user.secretLink">
                    Password Link
                </a>
                <a class="inputbutton1 rounded" href="/home">
                    Go Home
                </a>
            </div>

            <div class="littlenote mt-4">
                <p> If you're having trouble clicking the "Password link" button, copy and paste the URL below:</p>
                {{ user.secretLink }}
            </div>



        </div>
    </div>

</template>
